import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.css']
})
export class SlideshowComponent implements OnInit {
  visible: number = 1;
  @Input() data: any;
  carouselOptions = {
    nav: true,
    autoplay: true,
    loop: true,
    margin:25,
    navigation: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    singleItem: true,
    autoHeight: true,
    lazyLoad: true,
    mouseDrag: true,
    touchDrag: true,
    navText: true,
    responsiveClass: true,
    dots:true,
    responsive: {
      0: {
        items: 1,
      
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
      1500: {
        items: 1,
      }
    }
  };
  constructor() { }

  ngOnInit(): void {
  }

}
